import React, { Component } from 'react';
import comment_author from './../../../../../assets/comment_author.svg';
import moment from 'moment';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import {Dropdown,DropdownToggle,DropdownMenu} from 'reactstrap';
import {connect} from 'react-redux';
import get from 'lodash/get';
import { deepClone } from '../../../../../utils/copyObject';


class CommentsList extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      dropdownOpen : [],
      isCommentShown:""
    }
  }
  
  getDisplayName = (user) => {
    console.log('user----', user)
    let name = "";
    if(user.isDeleted) {
      name = "Deleted User";
    } else {
      if(user.firstName) {
        name = user.firstName
      }
      if(user.lastName) {
        name = name + " " + user.lastName;
      }
    }
    return name;
  }

  toggle = (id) => {
    const {dropdownOpen} = this.state;
    // console.log({id : id});
    const index = findIndex(dropdownOpen,{id : id});
    // console.log(index);
    if(index > -1) {
      dropdownOpen.splice(index,1);
    } else {
      dropdownOpen.push({id : id});
    }
    this.setState({dropdownOpen : dropdownOpen});
  }

  toggleComment = (index) => {
    let { comments } = this.props;
    const allComments = deepClone(comments);
    let commentShow = allComments[index]
    
    this.state.isCommentShown.indexOf(commentShow._id)>-1?
      this.setState({isCommentShown:""})
        :
      this.setState({isCommentShown:commentShow._id})
  }


  render() {
    const { comments,allComments } = this.props;
    console.log("allcomments", allComments);
    const {dropdownOpen} = this.state;
    const {profile} = this.props.user;
    let commentShow = this.state.isCommentShown
    return (
      <div>
        {
          allComments.map((comment,i) => {
            let id = comment._id
            let length = comment.text.length
            return (
              <div key={i} style={{ marginTop: '15px' }}>
                <div className="row" style={{ marginBottom: '5px' }}>
                  <div className="col-lg-8 col-md-8 commentList-user-profile">
                    <img src={get(comment, 'userId.profilePic',comment_author)} style={{ height: '22px', width: '22px', borderRadius: '50%' }} />
                    <span style={{
                      color: '#F06292', fontWeight: '600', fontSize: '14px',
                      marginLeft: '10px', lineHeight: '19px'
                    }}>
                      {
                        this.getDisplayName(comment.userId)
                      }
                    </span>
                  </div>
                  <div className="col-lg-4 col-md-4 text-right"
                  style={{display : comment._id && comment.userId._id === profile._id ? 'initial' : 'none'}}>
                    <Dropdown isOpen={(find(dropdownOpen,{id : comment._id}) != undefined)} 
                      direction={'right'}
                      toggle={() => this.toggle(comment._id)}>
                      <DropdownToggle
                        tag="span"
                        className="chart-item-menu"
                        style={{cursor:'pointer'}}>
                        <i className="comment-item flaticon-menu"></i>
                      </DropdownToggle>
                      <DropdownMenu className="comment-dropdown toolkit">
                        <div className="row" style={{paddingLeft:'32px'}} 
                          onClick={() => this.props.onDeleteComment(comment._id)}>
                            <i className="chart-item-menu flaticon-minus"></i>
                            <span style={{color:'#FFFFFF',fontSize:'13px',marginLeft:'12px',
                              marginTop:'3px',cursor:'pointer'}}>
                              Delete Comment
                            </span>
                        </div>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
                <div className="comment-value-container toolkit">
                  {
                    comment.text.length>55?
                    <div> 

                      {this.state.isCommentShown===id?
                        comment.text.slice(0,55)
                        :
                        <div> {comment.text.slice(0,55)}... <br/> </div>
                      }
                      <span className="showMore" onClick={()=>this.toggleComment(i)}>
                       { this.state.isCommentShown===id? 
                        null
                        :
                        "Show More"
                       }
                      </span> 


                         
                      { this.state.isCommentShown===id? 
                        comment.text.slice(55, length)
                        :
                        null
                       }
                       <span className="showMore" onClick={()=>this.toggleComment(i)}>
                      
                      { this.state.isCommentShown===id? 
                       <div> Show Less </div>
                       :
                       null
                      }

                     </span> 
                      </div>                                    
                  :
                  comment.text
                  }
                </div>

                <div className="comment-date-container">
                  {moment(comment.date).format("MMMM Do, YYYY hh:mmA")}
                </div>
              </div>
            )
          })
        }
        <div onClick={this.props.onSeeMoreComments} 
          className="mt20"
          style={{textAlign:'center',fontSize:'18px',lineHeight:'25px',
            display:comments.length === allComments.length ? 'none' : 'block', color:'#5099DE',
            cursor:'pointer'}}>
          See more comments
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user
  }
}

export default connect(mapStateToProps)(CommentsList);